import { useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { superAdminLoginApi } from "../../../services/super-admin-service/_auth";
import { errorToast } from "../../../components/Toast";
import Spinner from "../../../theme/Spinner";
import { ErrorMessage, Field, Form, Formik } from "formik";

const SuperAdminLogin = () => {
  const { loginSuperAdmin, isSuperAdmin } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (isSuperAdmin) {
      navigate("/super-admin/dashboard");
    }
  }, [isSuperAdmin, navigate]);

  const loginValidationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const loginInitialValues = {
    email: "",
    password: "",
  };

  const handleSubmit = async (values: any) => {
    setLoading(true);
    const result: any = await superAdminLoginApi(values);
    if (!result.isSuccess) {
      errorToast(result.message);
      setLoading(false);
      return;
    } else {
      loginSuperAdmin(result?.data?.token, result?.data?.user);
      navigate("/super-admin/dashboard");
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <div className="container-xxl">
      <div className="authentication-wrapper authentication-basic container-p-y">
        <div className="authentication-inner py-6">
          <div className="card">
            {loading && <Spinner isFullScreen={true} />}

            <div className="card-body">
              <div className="app-brand justify-content-center mb-6"></div>

              <Formik
                initialValues={loginInitialValues}
                validationSchema={loginValidationSchema}
                onSubmit={handleSubmit}
              >
                {({ handleChange, values }) => {
                  return (
                    <Form className="mb-4">
                      <div className="mb-6">
                        <label htmlFor="email" className="form-label">
                          Email
                        </label>
                        <Field
                          type="email"
                          onChange={handleChange}
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Enter your email"
                        />
                        <ErrorMessage
                          name="email"
                          className="text-danger"
                          component="div"
                        />
                      </div>
                      <div className="mb-6 form-password-toggle">
                        <label className="form-label" htmlFor="password">
                          Password
                        </label>
                        <div className="input-group input-group-merge">
                          <Field
                            type={showPassword ? "text" : "password"}
                            onChange={handleChange}
                            id="password"
                            className="form-control"
                            name="password"
                            placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                            aria-describedby="password"
                          />
                          <span
                            className="input-group-text cursor-pointer"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <i
                              className={
                                showPassword ? "ti ti-eye" : "ti ti-eye-off"
                              }
                            ></i>
                          </span>
                        </div>
                        <ErrorMessage
                          name="password"
                          className="text-danger"
                          component="div"
                        />
                      </div>
                      <div className="my-8">
                        <button
                          className="btn btn-primary d-grid w-100"
                          type="submit"
                        >
                          Login
                        </button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SuperAdminLogin;
